<template>
  <v-card class="full-screen-menu screen-height-container flex-content">
    <v-card-title class="d-flex flex-column">
      <v-row no-gutters class="w-100 mb-2">
        <v-col cols="6" md="4">
          <h2>
            <span v-show="showSettingModules">Configure</span> Agrify Insights
          </h2>
        </v-col>
        <v-col v-if="!isSmall" cols="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            clearable
            hide-details
          />
        </v-col>
        <v-col cols="6" md="4" class="d-flex justify-end">
          <v-btn
            icon
            @click="onToggleSettings"
            class="mr-1"
            :color="showSettingModules ? 'red' : 'primary'"
            ><v-icon>settings</v-icon></v-btn
          >
          <v-btn icon @click="onClose"><v-icon>close</v-icon></v-btn>
        </v-col>
        <v-col v-if="isSmall" cols="12">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            clearable
            single-line
            hide-details
          />
        </v-col>
      </v-row>
      <div
        class="w-100 d-flex justify-center flex-wrap"
        style="padding-top: 20px"
      >
        <v-btn
          v-for="heading in menuHeadings"
          :key="'btn-' + heading.label"
          class="mr-2"
          text
          color="primary"
          :class="{ 'd-none': !getHasChildren(heading) }"
          @click="scrollToHeading(heading)"
        >
          {{ heading.label }}
        </v-btn>
      </div>
    </v-card-title>

    <v-card-text ref="cardText" class="h-100 overflow-auto smooth-scroll">
      <div
        v-for="heading in menuHeadings"
        :class="{ 'd-none': !getHasChildren(heading) }"
        :key="heading.label"
      >
        <h2 :class="'heading-' + heading.ordinal">{{ heading.label }}</h2>
        <v-row no-gutters>
          <v-col
            v-for="item in getHeadingItems(heading)"
            md="4"
            class="nav-link d-flex align-center"
            :key="item.menuItem"
          >
            <v-btn
              class="favorite-btn"
              :class="{ favorited: item.isFavorite }"
              icon
              @click="toggleFavorite(item)"
            >
              <v-icon>{{
                item.isFavorite ? "mdi-heart" : "mdi-heart-outline"
              }}</v-icon>
            </v-btn>
            <v-list-item :to="{ path: item.route }" @click="saveRecent(item)">
              <v-list-item-icon>
                <v-icon
                  x-large
                  v-text="item.class"
                  :color="item.color"
                ></v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title v-text="item.menuItem"></v-list-item-title>
                <v-list-item-subtitle
                  v-text="item.description"
                  class="text-wrap"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </div>

      <div v-if="matchCount === 0">No menu items found.</div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import vuetifyToast from "@/vuetifyToast.js";
import Trimaster from "@/plugins/servers/trimaster.js";

export default {
  name: "FullScreenMenu",
  props: {
    facilityNavMenu: {
      type: Object,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      search: "",
      recents: [],
      simulatedMenuItems: [],
      showSettingModules: false,
    
    };
  },
  beforeMount() {
    this.loadRecents();
  },
  computed: {
    ...mapGetters(["getUser", "selectedRoleId"]),
    menuItems() {
      if (this.simulatedMenuItems.length === 0) {
        if (this.facilityNavMenu && this.facilityNavMenu.navmenu) {
          // return data.filter(d => d.courses.every(c => courses.includes(c.id)));
          return this.facilityNavMenu.navmenu;
        }
      } else {
        return this.simulatedMenuItems;
      }
      return [];
    },
    menuHeadings() {
      let headings = [
        {
          label: "Favorites",
          ordinal: -2,
        },
        /*
        {
          label: "Most Recent",
          ordinal: -1,
        },
        */
      ];
      let categories = [];
      this.menuItems.forEach((item) => {
        if (item.children) {
          item.children.forEach((child) => {
            if (child.category && !categories.includes(child.category)) {
              categories.push(child.category);
              headings.push({
                label: child.category,
                ordinal: child.categoryOrdinal,
              });
            }
          });
        }
      });
      headings.sort((a, b) => {
        return a.ordinal - b.ordinal;
      });
      headings.push({
        label: "Other",
        ordinal: 99999999,
      });
      return headings;
    },
    matchCount() {
      return this.menuHeadings.reduce((count, heading) => {
        return count + this.getHeadingItems(heading).length;
      }, 0);
    },
    isSmall() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },

  methods: {
    onToggleSettings() {
      this.showSettingModules = !this.showSettingModules;
    },
    async loadRecents() {
      let [res, err] = await Trimaster.get(
        "ag_navigationMenuRecents",
        this.getUser.apitoken,
        {
          filter: {
            limit: 10,
            order: "id desc",
            where: {
              user_id: this.getUser.id,
            },
          },
        }
      );
      let recents = [];
      res.forEach((result) => {
        if (
          !recents.find(
            (recent) =>
              recent.ag_navigationMenu_id === result.ag_navigationMenu_id
          )
        ) {
          recents.push(result);
        }
      });

      this.recents = recents;
    },
    onClose() {
      this.$emit("close");
    },
    async onMenuRoleChange(roleId) {
      let [res, err] = await Trimaster.get(
        "ag_navigationMenus/getMenuForCurrentUser",
        this.getUser.apitoken,
        {
          facility_id: this.getUser.facility_id,
          role_id: roleId,
        }
      );
      this.simulatedMenuItems = res;
    },
    getHeadingItems(heading) {
      let children = [];
      let me = this;
     
      this.menuItems.forEach((item) => {
        if (item.children) {
          item.children.forEach((child) => {
            if (
              !this.search ||
              !this.search.trim() ||
              (child.menuItem + " " + child.description)
                .toLowerCase()
                .indexOf(this.search.trim().toLowerCase()) !== -1
            ) {
              if (child.isConfigModule == this.showSettingModules) {
                children.push(child);
              }
            }
          });
        }
      });
      
      children.sort(function(a,b) {
        if (a.menuItem > b.menuItem) {
          return 1;
        } else {
          return -1;
        }
      });

      let items = children.filter((item) => {
        return (
          (heading.label === "Favorites" && item.isFavorite) ||
          (heading.label === "Most Recent" &&
            this.recents.find(
              (recent) => recent.ag_navigationMenu_id === item.id
            )) ||
          (heading.label === "Other" && !item.ag_navigationMenuCategory_id) ||
          item.category === heading.label
        );
      });
      if (heading.label === "Most Recent") {
        let orderedItems = [];
        this.recents.forEach((recent) => {
          if (
            !orderedItems.length ||
            !orderedItems.find(
              (item) => item.id === recent.ag_navigationMenu_id
            )
          ) {
            let matchingItem = items.find(
              (item) => item.id === recent.ag_navigationMenu_id
            );
            if (matchingItem) {
              orderedItems.push(matchingItem);
            }
          }
        });
        items = orderedItems;
      }
      return items;
    },
    getHasChildren(heading) {
      return !!this.getHeadingItems(heading).length;
    },
    toggleFavorite(item) {
      item.isFavorite = !item.isFavorite;
      if (!item.isFavorite) {
        Trimaster.post(
          "ag_navigationMenuFavorites/removeFavorite",
          this.getUser.apitoken,
          {
            ag_navigationMenu_id: item.id,
          }
        );
      } else {
        Trimaster.post(
          "ag_navigationMenuFavorites/addFavorite",
          this.getUser.apitoken,
          {
            ag_navigationMenu_id: item.id,
          }
        );
      }
    },
    saveRecent(item) {
      Trimaster.post(
        "ag_navigationMenuRecents/addRecent",
        this.getUser.apitoken,
        {
          ag_navigationMenu_id: item.id,
        }
      ).then(() => {
        this.loadRecents();
      });
      this.$emit("close");
    },
    scrollToHeading(heading) {
      let element = document.getElementsByClassName(
        "heading-" + heading.ordinal
      )[0];
      let card = this.$refs.cardText;
      card.scrollTop = element.offsetTop - card.offsetTop;
    },
  },
  watch: {
    selectedRoleId(newVal) {
      if (newVal) {
        this.onMenuRoleChange(newVal);
      }
    }
  },
};
</script>

<style lang="scss">
.full-screen-menu {
  .smooth-scroll {
    scroll-behavior: smooth;
  }

  .favorite-btn {
    opacity: 0;
  }

  .favorite-btn.favorited {
    opacity: 1;
  }

  .nav-link:hover {
    .favorite-btn {
      opacity: 1;
    }
  }
}
</style>
